import { render } from "./Notification.vue?vue&type=template&id=7b6cded4&scoped=true"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"

import "./Notification.vue?vue&type=style&index=0&id=7b6cded4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b6cded4"],['__file',"src/components/MainHeader/Notification.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b6cded4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b6cded4', __exports__)) {
    api.reload('7b6cded4', __exports__)
  }
  
  module.hot.accept("./Notification.vue?vue&type=template&id=7b6cded4&scoped=true", () => {
    api.rerender('7b6cded4', render)
  })

}


export default __exports__